





















import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "Tos",
  components: {},
})
export default class TosText extends Vue {
  private close() {
    this.$emit("dialog:clickClose");
  }
}
